import { useState, useContext, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import TodoForm from "./TodoForm";
import TodoList from "./TodoList";
import "./payment-section.scss";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import Loader from "utils/Loader";
function MyAddress({
  item,
  setItems,
  ChangeModalStar,
  user_id,
  addressId,
  handleAddress,
}) {
  const [todos, setTodos] = useState([]);
  const [updater, setUpdater] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const addTodoHandler = (input, input2) => {
    const newTodo = {
      id: Math.floor(Math.random() * 1000),
      addrss: input,
      girande: input2,
      isCompleted: false,
    };
    setTodos([...todos, newTodo]);
  };
  const deleteHandler = (id) => {
    setIsLoading(true);
    Swal.fire({
      icon: "warning",
      title: "آیا از حذف این آدرس مطمئن هستید؟",
      showCancelButton: true,
      cancelButtonText: "انصراف",
      confirmButtonText: "حذف",
      cancelButtonColor: "#EF394E",
      confirmButtonColor: "#439B58",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        connection("api/Update_usersAddress", {
          keyvalues: `status,-1`,
          conditions: `id/=/${id}`,
        }).then((data) => {
          setIsLoading(false);
          if (data.status == 1) {
            toast.success("آدرس با موفقیت حذف شد.");
            setUpdater(() => !updater);
            addressId == id && handleAddress("-1");
            setIsLoading(false);
          } else {
            toast.error("مشکلی در حذف آدرس به وجود آمده است.");
            setIsLoading(false);
          }
        });
      }
    });

    // const filteredTodos = todos.filter((todo) => todo.id !== id);
    // setTodos(filteredTodos);
  };
  const add = () => {
    if (addressId == "-1") {
      toast.error("لطفا آدرس مورد نظر را انتخاب کنید.");
    } else {
      setItems(item + 1);
      ChangeModalStar(3);
    }
  };

  useEffect(() => {
    connection("api/Find_usersAddress", {
      conditions: `status/=/0@@user_id/=/${user_id}`,
    }).then((data) => {
      setTodos(data);
      setIsLoading(false);
    });
  }, [updater]);

  return (
    <div
      className={` d-flex justify-content-between flex-column align-items-between mx-auto`}
      style={{ backgroundColor: "white", borderRadius: "10px", width: "90%" }}
    >
      {isLoading && <Loader />}
      <div className="container">
        <div>
          <TodoForm
            addTodoHandler={addTodoHandler}
            id={user_id}
            setUpdater={setUpdater}
            setIsLoading={setIsLoading}
          />
          <h5>لیست آدرس های من</h5>
          <TodoList
            todos={todos}
            deleteHandler={deleteHandler}
            handleAddress={handleAddress}
            addressId={addressId}
          />
        </div>
      </div>

      <div class="modal-footer px-5 w-100 d-flex justify-content-end ">
        <div></div>
        <button
          type="button"
          className={`btn text-light continueHover `}
          style={{ backgroundColor: "#f04937" }}
          onClick={add}
        >
          {" "}
          ادامه
        </button>
      </div>
    </div>
  );
}

export default MyAddress;
